import { render } from "./ImageViewer.vue?vue&type=template&id=389541ad"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Gallery/ImageViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "389541ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('389541ad', __exports__)) {
    api.reload('389541ad', __exports__)
  }
  
  module.hot.accept("./ImageViewer.vue?vue&type=template&id=389541ad", () => {
    api.rerender('389541ad', render)
  })

}


export default __exports__